module.exports = __webpack_public_path__ + "static/img/marketDepthHero.99b15cc4.png";